<app-breadcrumb [title]="'Emergencia PESV'" [items]="['PESV', 'Diagnóstico']" [active_item]="'Emergencia'">
</app-breadcrumb>
<div class="container-fluid">
  <div class="card">
    <div class="card-header bg-primary text-white">
      <h5 class="mb-0"><strong>EMERGENCIA PESV</strong></h5>
    </div>
    <div class="card-body">
      <ul ngbNav #nav="ngbNav" class="nav-tabs" (navChange)="tabActiva = $event.nextId">
        <li [ngbNavItem]="1">
          <a ngbNavLink><strong>FORMULARIO EMERGENCIA</strong></a>
          <ng-template ngbNavContent>
            <div class="card card-absolute rounded mt-3">
              <div class="card-body">
                <form [formGroup]="form" (ngSubmit)="guardar()" novalidate>
                  <div class="row g-3 mb-3">
                    <div class="col-md-4">
                      <label class="form-label"><strong>N° COLABORADORES:</strong><a class="text-danger">*</a></label>
                      <input type="number" class="form-control" placeholder="Ingrese número de colaboradores"
                        formControlName="numero_colaboradores"
                        [ngClass]="{ 'is-invalid': form.get('numero_colaboradores')?.touched && form.get('numero_colaboradores')?.invalid }" />
                      <div class="invalid-feedback"
                        *ngIf="form.get('numero_colaboradores')?.touched && form.get('numero_colaboradores')?.invalid">
                        El número de colaboradores es obligatorio.
                      </div>
                    </div>
                    <div class="col-md-4">
                      <label class="form-label"><strong>DESCRIPCIÓN EQUIPOS:</strong><a
                          class="text-danger">*</a></label>
                      <ng-select [items]="opcionesEquiposEmergencia" bindLabel="descripcion"
                        bindValue="descripcion" [clearable]="false" placeholder="Seleccione"
                        formControlName="descripcion_equipos"
                        [ngClass]="{ 'is-invalid': form.get('descripcion_equipos')?.touched && form.get('descripcion_equipos')?.invalid }">
                      </ng-select>
                      <div class="invalid-feedback"
                        *ngIf="form.get('descripcion_equipos')?.touched && form.get('descripcion_equipos')?.invalid">
                        La descripción es obligatoria.
                      </div>
                    </div>
                    <div class="col-md-4">
                      <label class="form-label"><strong>SIMULACRO:</strong><a class="text-danger">*</a></label>
                      <select class="form-select" formControlName="simulacro"
                        [ngClass]="{ 'is-invalid': form.get('simulacro')?.touched && form.get('simulacro')?.invalid }">
                        <option [ngValue]="null">Seleccione</option>
                        <option [ngValue]="1">Sí</option>
                        <option [ngValue]="0">No</option>
                      </select>
                      <div class="invalid-feedback"
                        *ngIf="form.get('simulacro')?.touched && form.get('simulacro')?.invalid">
                        El campo simulacro es obligatorio.
                      </div>
                    </div>
                    <div class="col-md-4">
                      <label class="form-label"><strong>ÚLTIMO SIMULACRO:</strong><a class="text-danger">*</a></label>
                      <input type="date" class="form-control" placeholder="Seleccione fecha"
                        formControlName="ultimo_simulacro" [attr.max]="maxFechaHoy"
                        [ngClass]="{ 'is-invalid': form.get('ultimo_simulacro')?.touched && form.get('ultimo_simulacro')?.invalid }" />
                      <div class="invalid-feedback"
                        *ngIf="form.get('ultimo_simulacro')?.touched && form.get('ultimo_simulacro')?.invalid">
                        La fecha es obligatoria y no puede ser futura.
                      </div>
                    </div>
                    <div class="col-md-4">
                      <label class="form-label"><strong>TIPO SIMULACRO:</strong><a class="text-danger">*</a></label>
                      <select class="form-select" formControlName="tipo_simulacro"
                        [ngClass]="{ 'is-invalid': form.get('tipo_simulacro')?.touched && form.get('tipo_simulacro')?.invalid }">
                        <option [ngValue]="null">Seleccione</option>
                        <option [ngValue]="1">EJERCICIO PRÁCTICO</option>
                        <option [ngValue]="2">SIMULACIÓN DE ESCRITORIO</option>
                      </select>
                      <div class="invalid-feedback"
                        *ngIf="form.get('tipo_simulacro')?.touched && form.get('tipo_simulacro')?.invalid">
                        El tipo de simulacro es obligatorio.
                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-center gap-2">
                    <button type="submit" class="btn btn-primary" [disabled]="form.invalid || guardando">
                      {{ guardando ? 'Guardando...' : 'Guardar' }}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </ng-template>
        </li>
        <li [ngbNavItem]="2">
          <a ngbNavLink><strong>LISTADO EMERGENCIAS</strong></a>
          <ng-template ngbNavContent>
            <div class="card card-absolute rounded mt-3">
              <div class="card-body">
                <div *ngIf="cargando" class="text-center py-4">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Cargando...</span>
                  </div>
                </div>
                <!-- Buscador y filtro de estado -->
                <div class="row mb-3">
                  <div class="col-md-3">
                    <select class="form-select" [(ngModel)]="filtroEstado" (change)="aplicarFiltro()">
                      <option [ngValue]="null">Todos</option>
                      <option [ngValue]="1">Activos</option>
                      <option [ngValue]="0">Inactivos</option>
                    </select>
                  </div>
                  <div class="col-md-4 ms-auto">
                    <div class="input-group">
                      <input type="text" class="form-control"
                        placeholder="Buscar por N° colaboradores, descripción, simulacro..." [(ngModel)]="filtro"
                        (input)="aplicarFiltro()" />
                      <span class="input-group-text">
                        <i class="fa fa-search"></i>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="table-responsive mt-4">
                  <table class="table table-bordered table-hover" id="tblEmergenciasPesv">
                    <thead class="bg-primary text-white">
                      <tr>
                        <th>#</th>
                        <th class="text-center">N° COLABORADORES</th>
                        <th class="text-center">DESCRIPCIÓN EQUIPOS</th>
                        <th class="text-center">SIMULACRO</th>
                        <th class="text-center"> ÚLTIMO SIMULACRO</th>
                        <th class="text-center">TIPO SIMULACRO</th>
                        <th class="text-center">ESTADO</th>
                        <th class="text-center">ACCIONES</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let e of emergenciasFiltradas | paginate: { itemsPerPage: pageSize, currentPage: page }; let i = index">
                        <td class="text-center">{{ ((page - 1) * pageSize) + i + 1 }}</td>
                        <td class="text-center">{{ e.numero_colaboradores }}</td>
                        <td class="text-center">{{ e.descripcion_equipos }}</td>
                        <td class="text-center">{{ e.simulacro === 1 ? 'Sí' : e.simulacro === 0 ? 'No' : '' }}</td>
                        <td class="text-center">{{ e.ultimo_simulacro | date:'dd/MM/yyyy' }}</td>
                        <td class="text-center">
                          {{ e.tipo_simulacro === 1 ? 'EJERCICIO PRÁCTICO' : (e.tipo_simulacro === 2 ? 'SIMULACIÓN DE
                          ESCRITORIO' : '') }}
                        </td>
                        <td class="text-center">
                          <span class="badge" [ngClass]="e.estado === 1 ? 'bg-success' : 'bg-secondary'">
                            {{ e.estado === 1 ? 'Activo' : 'Inactivo' }}
                          </span>
                        </td>
                        <td class="text-center">
                          <ul class="d-flex justify-content-center align-items-center gap-2 mb-0 p-0" style="list-style: none;">
                            <!-- Editar -->
                            <li class="edit list-inline-item" [class.disabled]="e.estado !== 1"
                              [ngbTooltip]="e.estado !== 1 ? 'Solo se puede editar si está activo' : 'Editar'"
                              (click)="e.estado === 1 && abrirModalEditar(editarEmergenciaModal, e)">
                              <a href="javascript:void(0)" [attr.aria-disabled]="e.estado !== 1 ? true : null"
                                [style.pointer-events]="e.estado !== 1 ? 'none' : 'auto'"
                                [style.opacity]="e.estado !== 1 ? 0.5 : 1">
                                <i class="icon-pencil-alt"></i>
                              </a>
                            </li>
                            <!-- Activar -->
                            <li class="edit" *ngIf="e.estado === 0" (click)="activar(e.id!)" ngbTooltip="Activar">
                              <a href="javascript:void(0)"><i class="icon-check-box text-success"></i></a>
                            </li>
                            <!-- Inactivar -->
                            <li *ngIf="e.estado === 1" class="delete list-inline-item" (click)="eliminar(e.id!)"
                              ngbTooltip="Inactivar">
                              <a href="javascript:void(0)"><i class="icon-close text-danger"></i></a>
                            </li>
                            <ng-template #editarEmergenciaModal let-modal>
                              <div class="modal-header">
                                <h5 class="modal-title">Editar Emergencia</h5>
                                <button type="button" class="btn-close" aria-label="Close"
                                  (click)="modal.dismiss()"></button>
                              </div>
                              <form [formGroup]="formEditar" (ngSubmit)="guardarEdicionEmergencia(modal)" novalidate>
                                <div class="modal-body">
                                  <div class="row g-3 mb-3">
                                    <div class="col-md-4">
                                      <label class="form-label"><strong>N° COLABORADORES:</strong><a
                                          class="text-danger">*</a></label>
                                      <input type="number" class="form-control"
                                        placeholder="Ingrese número de colaboradores"
                                        formControlName="numero_colaboradores"
                                        [ngClass]="{ 'is-invalid': formEditar.get('numero_colaboradores')?.touched && formEditar.get('numero_colaboradores')?.invalid }" />
                                      <div class="invalid-feedback"
                                        *ngIf="formEditar.get('numero_colaboradores')?.touched && formEditar.get('numero_colaboradores')?.invalid">
                                        El número de colaboradores es obligatorio.
                                      </div>
                                    </div>
                                    <div class="col-md-4">
                                      <label class="form-label"><strong>DESCRIPCIÓN EQUIPOS:</strong><a
                                          class="text-danger">*</a></label>
                                      <ng-select [items]="opcionesEquiposEmergencia" bindLabel="descripcion"
                                        bindValue="descripcion" [clearable]="false" placeholder="Seleccione"
                                        formControlName="descripcion_equipos"
                                        [ngClass]="{ 'is-invalid': formEditar.get('descripcion_equipos')?.touched && formEditar.get('descripcion_equipos')?.invalid }">
                                      </ng-select>
                                      <div class="invalid-feedback"
                                        *ngIf="formEditar.get('descripcion_equipos')?.touched && formEditar.get('descripcion_equipos')?.invalid">
                                        La descripción es obligatoria.
                                      </div>
                                    </div>
                                    <div class="col-md-4">
                                      <label class="form-label"><strong>SIMULACRO:</strong><a
                                          class="text-danger">*</a></label>
                                      <select class="form-select" formControlName="simulacro"
                                        [ngClass]="{ 'is-invalid': formEditar.get('simulacro')?.touched && formEditar.get('simulacro')?.invalid }">
                                        <option [ngValue]="null">Seleccione</option>
                                        <option [ngValue]="1">Sí</option>
                                        <option [ngValue]="0">No</option>
                                      </select>
                                      <div class="invalid-feedback"
                                        *ngIf="formEditar.get('simulacro')?.touched && formEditar.get('simulacro')?.invalid">
                                        El campo simulacro es obligatorio.
                                      </div>
                                    </div>
                                    <div class="col-md-4">
                                      <label class="form-label"><strong>ÚLTIMO SIMULACRO:</strong><a
                                          class="text-danger">*</a></label>
                                      <input type="date" class="form-control" placeholder="Seleccione fecha"
                                        formControlName="ultimo_simulacro" [attr.max]="maxFechaHoy"
                                        [ngClass]="{ 'is-invalid': formEditar.get('ultimo_simulacro')?.touched && formEditar.get('ultimo_simulacro')?.invalid }" />
                                      <div class="invalid-feedback"
                                        *ngIf="formEditar.get('ultimo_simulacro')?.touched && formEditar.get('ultimo_simulacro')?.invalid">
                                        La fecha es obligatoria y no puede ser futura.
                                      </div>
                                    </div>
                                    <div class="col-md-4">
                                      <label class="form-label"><strong>TIPO SIMULACRO:</strong><a
                                          class="text-danger">*</a></label>
                                      <select class="form-select" formControlName="tipo_simulacro"
                                        [ngClass]="{ 'is-invalid': formEditar.get('tipo_simulacro')?.touched && formEditar.get('tipo_simulacro')?.invalid }">
                                        <option [ngValue]="null">Seleccione</option>
                                        <option [ngValue]="1">EJERCICIO PRÁCTICO</option>
                                        <option [ngValue]="2">SIMULACIÓN DE ESCRITORIO</option>
                                      </select>
                                      <div class="invalid-feedback"
                                        *ngIf="formEditar.get('tipo_simulacro')?.touched && formEditar.get('tipo_simulacro')?.invalid">
                                        El tipo de simulacro es obligatorio.
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button type="button" class="btn btn-light"
                                    (click)="modal.dismiss()">Cancelar</button>
                                  <button type="submit" class="btn btn-primary"
                                    [disabled]="formEditar.invalid || guardando">
                                    <span *ngIf="!guardando">Guardar cambios</span>
                                    <span *ngIf="guardando">Guardando...</span>
                                  </button>
                                </div>
                              </form>
                            </ng-template>
                          </ul>
                        </td>
                      </tr>
                      <tr *ngIf="!emergenciasFiltradas.length">
                        <td colspan="8" class="text-center">No hay registros.</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="d-flex justify-content-between align-items-center mt-4">
                  <div class="d-flex align-items-center">
                    <label for="pageSizeEmergenciaPesv" class="me-2">Mostrar:</label>
                    <select id="pageSizeEmergenciaPesv" class="form-select w-auto" [(ngModel)]="pageSize" (change)="page = 1">
                      <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
                    </select>
                    <span class="ms-2">registros por pagina</span>
                  </div>

                  <div class="text-center flex-grow-1">
                    Total Registros:
                    <a class="badge badge-primary"><b>{{ emergenciasFiltradas?.length || 0 }}</b></a>
                  </div>

                  <div class="text-end paginador-personalizado">
                    <pagination-controls (pageChange)="page = $event" [maxSize]="5" [directionLinks]="true"
                      [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente">
                    </pagination-controls>
                  </div>
                </div>

                <div class="mt-4">
                  <div class="btn-showcase text-center">
                    <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Exportar a Excel"
                      (click)="exportarExcel('tblEmergenciasPesv','listado_emergencias_pesv')">
                      <i class="icofont icofont-file-excel"></i> EXCEL
                    </button>

                    <button class="btn btn-outline-danger-2x" type="button" placement="top" ngbTooltip="Exportar a PDF"
                      (click)="exportToPDF('tblEmergenciasPesv','listado_emergencias_pesv','Listado Emergencias PESV')">
                      <i class="icofont icofont-file-pdf"></i> PDF
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav" class="mt-2"></div>
    </div>
  </div>
</div>